import { useEffect, useState, type RefObject } from 'react';

/**
 * True while the pointer is over the element (via mouseenter/mouseleave).
 * Syncs on attach if the pointer is already inside (`:hover`).
 */
export const useElementHover = (scopeRef: RefObject<HTMLElement | null>): boolean => {
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const el = scopeRef.current;
    if (!el) {
      return;
    }

    const onEnter = () => setIsHovered(true);
    const onLeave = () => setIsHovered(false);

    el.addEventListener('mouseenter', onEnter);
    el.addEventListener('mouseleave', onLeave);

    if (el.matches(':hover')) {
      onEnter();
    }

    return () => {
      el.removeEventListener('mouseenter', onEnter);
      el.removeEventListener('mouseleave', onLeave);
    };
  }, [scopeRef]);

  return isHovered;
};
